import { makeStyles } from '@mui/styles';
import { Colors } from '../../../ui/theme/colors';

export const useCourierDetailsStyles = makeStyles((theme) => ({
  // Plain white in place of the timeline's gradient, to match the notes and deliveries cards beside it.
  historyCard: {
    background: Colors.white,
    maxWidth: 'none'
  },
  deliveries: {
    [theme.breakpoints.down('md')]: {
      // InfiniteTable wraps the list's Paper in a div of its own.
      '& > div:first-child > .MuiPaper-root': {
        marginBottom: 0
      }
    }
  },

  sideColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    '& > .MuiBox-root:first-child': {
      marginBottom: 0
    }
  }
}));
